import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[AppErrorBoundary]", error, errorInfo?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.assign("/");
  };

  handleLogout = () => {
    try {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("next");
    } finally {
      window.location.assign("/logout");
    }
  };

  render() {
    const { error } = this.state;

    if (!error) {
      return this.props.children;
    }

    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
          backgroundColor: "#eef2f7",
        }}
      >
        <Card sx={{ maxWidth: 560, width: "100%" }}>
          <CardContent>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
              Ocurrió un error al cargar la vista
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
              Puedes recargar la página o volver al inicio. Si el problema
              persiste, reporta el detalle mostrado abajo.
            </Typography>

            <Box
              component="pre"
              sx={{
                m: 0,
                mb: 2,
                p: 1.5,
                borderRadius: 1.5,
                backgroundColor: "rgba(15, 23, 42, 0.06)",
                fontSize: 12,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxHeight: 220,
                overflow: "auto",
              }}
            >
              {String(error?.message || error)}
            </Box>

            <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
              <Button variant="contained" onClick={this.handleReload}>
                Recargar
              </Button>
              <Button variant="outlined" onClick={this.handleGoHome}>
                Ir al inicio
              </Button>
              <Button color="inherit" onClick={this.handleLogout}>
                Cerrar sesión
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    );
  }
}

AppErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default AppErrorBoundary;
